var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 163,
    height: 125,
    viewBox: "0 0 163 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.926 69.7447C177.543 110.979 142.532 124.174 99.1977 124.174C55.8639 124.174 0 108.264 0 69.7447C0 31.2258 35.129 0 78.4628 0C121.797 0 132.421 20.7349 156.926 69.7447Z",
    fill: "#EDF5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67.2227L59.6594 73.8722V97.8682L40 90.3514V67.2227Z",
    fill: "#4F5BD5",
    fillOpacity: 0.65
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3706 29.927L79.3191 34.5527V67.0775L59.3706 61.0062V29.927Z",
    fill: "#42D5B0",
    fillOpacity: 0.65
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3191 67.2214L59.6597 73.8709V97.867L79.3191 90.3502V67.2214Z",
    fill: "#4F5BD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1409 99.3137L123.408 76.3295L118.927 75.0285L59.6597 97.8682L64.1409 99.3137Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2456 93.9636L106.495 85.4349L102.592 83.9894L80.7644 92.5181L85.2456 93.9636Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0273 28.4817L79.319 34.553V90.3511L99.0273 82.8342V28.4817Z",
    fill: "#42D5B0"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.687 31.5168L98.9782 38.8891V82.8337L118.687 75.1278V31.5168Z",
    fill: "#F9BA0F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40 67.2224L59.2258 61.1511L79.3189 67.2224",
    stroke: "#4F5BD5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3706 29.9267L79.4637 24L98.9786 28.4812",
    stroke: "#42D5B0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M96.3765 27.7567L99.123 27.0339L118.638 31.5151",
    stroke: "#F9BA0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewards);
export default __webpack_public_path__ + "static/media/rewards.594b8465e058e3ac08f21b0a590e3490.svg";
export { ForwardRef as ReactComponent };